/*
 * @Description:
 * @Author: liXinMan
 * @Date: 2021-12-14 09:25:36
 * @LastEditors: liXinMan
 * @LastEditTime: 2021-12-30 13:59:26
 */
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Axios from 'axios'

import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css' //引用 element-ui 样式
import i18n from './language'
import animated from 'animate.css'
Vue.use(ElementUI) //最后要use ElementUI ，不然会报错
Vue.use(animated)
Vue.prototype.$axios = Axios
Vue.prototype.$store = store
Axios.defaults.baseURL = './api'
Vue.config.productionTip = false

// eslint-disable-next-line
const _hmt = _hmt || [];

// eslint-disable-next-line
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function() {
	const hm = document.createElement("script");
	hm.src = "https://hm.baidu.com/hm.js?bd9cde1deac982980abc2e8c0f0a7c62";
	const s = document.getElementsByTagName("script")[0];
	s.parentNode.insertBefore(hm, s);
})()

new Vue({
	router,
	store,
	i18n,
	data: function () {
		return {
			play: false
		}
	},
	render: (h) => h(App)
}).$mount('#app')
